import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button, Label } from '@nike/podium';
import { Input } from '~/components/shadcn/input';
import { useColumnState } from '~/atoms/hooks/useColumnState';
import { useSavedViews } from '~/atoms/hooks/useSavedViews';
import { useSetAtom } from 'jotai';
import { showToastAtom } from '~/atoms/pageActions';
import GenericModal from './GenericModal';
import log from '~/logger';
const DUPLICATE_NAME_ERROR_MESSAGE = 'A view with this name already exists. Please choose a different name.';
export default function SaveView({ open, onOpenChange, defaultValue = '' }) {
    const [viewName, setViewName] = useState(defaultValue);
    const { saveNewViewAsync } = useColumnState();
    const { savedViews, refreshSavedViews } = useSavedViews();
    const showToast = useSetAtom(showToastAtom);
    const isDuplicateName = React.useMemo(() => {
        if (!viewName.trim())
            return false;
        return savedViews.some((view) => view.name.toLowerCase() === viewName.trim().toLowerCase());
    }, [viewName, savedViews]);
    const handleSave = async () => {
        if (viewName.trim()) {
            const trimmedName = viewName.trim();
            onOpenChange(false);
            try {
                await saveNewViewAsync(trimmedName);
                refreshSavedViews();
                showToast({ message: 'View Saved Successfully', type: 'success' });
            }
            catch (error) {
                log.error('Failed to save view:', error);
                showToast({ message: 'Failed to Save View', type: 'critical' });
            }
        }
    };
    const handleCancel = () => {
        onOpenChange(false);
    };
    React.useEffect(() => {
        if (open) {
            setViewName(defaultValue);
        }
    }, [open, defaultValue]);
    return (_jsx(GenericModal, { open: open, onOpenChange: onOpenChange, title: "Save View", allowOutsideInteraction: false, testId: "save-view-modal", className: "min-w-[40%]", footer: _jsxs(_Fragment, { children: [_jsx(Button, { className: "!bg-gray-200 hover:!bg-gray-300 !text-black", onClick: handleCancel, "aria-label": "Cancel Save", children: "Cancel" }), _jsx(Button, { onClick: handleSave, disabled: !viewName.trim() || isDuplicateName, "aria-label": "Save View", children: "Save" })] }), children: _jsxs("div", { className: "w-full", children: [_jsx(Label, { htmlFor: "view-name", children: "Name" }), _jsx(Input, { id: "view-name", value: viewName, onChange: (e) => setViewName(e.target.value), placeholder: "Enter view name", className: "rounded-none pb-2 mt-1", onKeyDown: (e) => {
                        if (e.key === 'Enter' && viewName.trim() && !isDuplicateName) {
                            handleSave();
                        }
                    } }), isDuplicateName && (_jsx("div", { className: "text-red-600 text-sm mt-1", role: "alert", children: DUPLICATE_NAME_ERROR_MESSAGE }))] }) }));
}
